import React, {Fragment} from "react";
import {Box} from "@mui/system";
import {useTheme} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery/useMediaQuery";
import chatdeskLogo from "components/images/logos/logo_chatdesk.svg";
import {buttonContained} from "./ButtonContained";
import BasicModal from "../../../common/BasicModal";
import {basicModalStyle} from "./basicModalStyles";
import styles from "../styles/Channels.module.css";

export default function ConnectChannelErrorModal({ open, handleOpen, handleClose, action, message }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const {SolidButton} = buttonContained;

  return(
    <Fragment>
      <BasicModal
        open={open}
        handleClose={handleClose}
        handleOpen={handleOpen}
        withoutTitle
        style={basicModalStyle}
      >

        <Box sx={isMobile ? {marginTop: '10px'} : {}}>
          <Box sx={{display: 'flex', justifyContent: 'center', }}>
            <img src={chatdeskLogo} className={styles.remarkableLogo} alt={`Chatdesk logo`}/>
          </Box>
          <Box className={isMobile ? styles.headerTextMobile : styles.headerText}>
            Channel connection failed
          </Box>
          <Box className={isMobile ? styles.descriptionTextMobile : styles.descriptionText}>
            {message}
          </Box>

          <Box className={styles.buttonContainer}>
              <SolidButton label={'Try again'} action={handleClose}/>
          </Box>
        </Box>
      </BasicModal>
    </Fragment>
  )
}